import DeleteIcon from "@mui/icons-material/Delete";
import { usePopup } from "@nodeon/react-components";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { ProjectListDto } from "~/api/GeneratedApi";
import GenericTable, {
  CustomColumn,
  CustomTableProps,
} from "~/components/GenericTable";
import PaddedBox from "~/components/PaddedBox";
import { ProjectCreationDialog } from "./components/ProjectCreationDialog";
import { MapAreaSmartAutocompleteForm } from "./MapAreaSmartAutocompleteForm";
import { useProjects, useRemoveProject } from "./Wpr/hooks/useProjects";

// TODO REMOVE THIS
export type DemoPTOPProjectListDto = ProjectListDto & {
  demo?: boolean;
};

export const ProjectsPage = () => {
  const { t } = useTranslation();

  const { show, confirm } = usePopup();

  const { removeProject } = useRemoveProject();

  const { data: projects } = useProjects();
  const refetchRef = useRef<() => void>();

  const tableProps = React.useMemo(
    (): CustomTableProps<DemoPTOPProjectListDto & { demo: boolean }> => ({
      title: t("projects:projects-list"),
      options: {
        filtering: false,
        pageSize: 20,
        idSynonym: "id",
      },
      actions: [
        ({ link, demo }) => ({
          // TODO REMOVE DEMO
          hidden: demo,
          icon: "visibility",
          tooltip:
            link === null ? t("projects:projectNotLinked") : t("general:view"),
          isLink: true,
          basePath: (id: string) => `/projects/${id}/details`,
          disabled: link === null,
        }),
        {
          icon: "delete",
          tooltip: t("general:delete"),

          onClick: (_e, val) => {
            if (Array.isArray(val)) return;
            void confirm({
              title: t("general:are-you-sure"),
              description: t("general:delete-with-name", {
                name: val.name,
              }),
              icon: <DeleteIcon />,
            })
              .then(() => {
                removeProject(val.id);
              })
              .catch(() => {});
          },
        },
        {
          icon: "add",
          tooltip: t("projects:add-project"),
          isFreeAction: true,
          onClick: () => {
            void show(
              <ProjectCreationDialog
                onSubmitted={() => refetchRef.current?.()}
              />,
              { noDialog: true },
            );
          },
        },
      ],
    }),
    [confirm, removeProject, show, t],
  );

  const columns = React.useMemo((): CustomColumn<DemoPTOPProjectListDto>[] => {
    return [
      { field: "projectId", title: t("projects:id"), width: "auto" },
      { field: "name", title: t("projects:name"), width: "auto" },

      { field: "clientName", title: t("projects:clientName"), width: "auto" },

      {
        field: "linkitys" as keyof DemoPTOPProjectListDto,
        title: t("projects:linkitys"),
        width: "20%",
        render: ({ link, id, demo }) => {
          if (demo) return null;
          return (
            <MapAreaSmartAutocompleteForm
              mapAreaProp={link?.mapAreaId ?? null}
              projectId={id}
              key={id}
              reFetch={refetchRef.current}
            />
          );
        },
      },
    ];
  }, [t]);

  return (
    <PaddedBox p={3}>
      <GenericTable<DemoPTOPProjectListDto>
        data={projects ?? []}
        columns={columns}
        // fetch={getProjects}
        tableProps={tableProps as CustomTableProps<DemoPTOPProjectListDto>}
        // getRefetch={(r) => {
        //   refetchRef.current = r;
        // }}
      />
    </PaddedBox>
  );
};
